import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FieldArrayType, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-repeat-section',
  template: `
    <div *ngFor="let field of field.fieldGroup; let i = index;" class="row item-row">
      <formly-field class="col" [field]="field"></formly-field>
    </div>
  `,
  imports: [CommonModule, FormlyModule, FormsModule, ReactiveFormsModule]
})
export class RepeatTypeComponent extends FieldArrayType {}
